import { a11yHelpers, getA11yHelpersState } from './userway';

export const FEATURES = {
  BIGGER_TEXT: 'Bigger Text',
  INVERT_COLORS: 'Invert Colors',
  DARK_CONTRAST: 'Dark Contrast',
  HIGHLIGHT_LINKS: 'Highlight Links',
  PAUSE_ANIMATIONS: 'Pause Animations',
  LEGIBLE_FONTS: 'Legible Fonts',
  BIG_CURSOR: 'Big Cursor',
  RESET: 'Reset All',
};

export const FEATURES_KEYS = {
  'userway-s4': [FEATURES.BIGGER_TEXT],
  'userway-s3': [FEATURES.INVERT_COLORS, FEATURES.DARK_CONTRAST],
  'userway-s6': [FEATURES.HIGHLIGHT_LINKS],
  'userway-s13': [FEATURES.PAUSE_ANIMATIONS],
  'userway-s7': [FEATURES.LEGIBLE_FONTS],
  'userway-s2': [FEATURES.BIG_CURSOR],
  'userway-s8': [FEATURES.RESET],
};

export const getUwActiveFeatures = () => {
  const state = getA11yHelpersState();

  return Object.keys(state).reduce((result, featureKey) => {
    const featureValue = state[featureKey].value;
    if (featureValue > 0) {
      const features = FEATURES_KEYS[featureKey as keyof typeof FEATURES_KEYS];

      if (!features) {
        return result;
      }

      const index = featureValue - 1;
      const activeFeature = features[index];

      return [...result, activeFeature];
    }

    return result;
  }, [] as string[]);
};

export const toggleFeature = ({
  name,
  isActive,
}: {
  name: string;
  isActive: boolean;
}) => {
  switch (name) {
    case FEATURES.BIGGER_TEXT: {
      if (!isActive) {
        a11yHelpers.disableBigText();
      } else {
        a11yHelpers.enableBigText();
        a11yHelpers.enableBigText();
      }
      return;
    }
    case FEATURES.INVERT_COLORS: {
      if (!isActive) {
        a11yHelpers.disableContrast();
      } else {
        a11yHelpers.enableContrast(1);
      }
      return;
    }
    case FEATURES.BIG_CURSOR: {
      if (!isActive) {
        a11yHelpers.disableBigCursor();
      } else {
        a11yHelpers.enableBigCursor();
      }
      return;
    }
    case FEATURES.DARK_CONTRAST: {
      if (!isActive) {
        a11yHelpers.disableContrast();
      } else {
        a11yHelpers.enableContrast(2);
      }
      return;
    }
    case FEATURES.HIGHLIGHT_LINKS: {
      if (!isActive) {
        a11yHelpers.disableHighlight();
      } else {
        a11yHelpers.enableHighlight();
      }
      return;
    }
    case FEATURES.PAUSE_ANIMATIONS: {
      if (!isActive) {
        a11yHelpers.enableAnimation();
      } else {
        a11yHelpers.disableAnimation();
      }
      return;
    }
    case FEATURES.LEGIBLE_FONTS: {
      if (!isActive) {
        a11yHelpers.disableLegibleFonts();
      } else {
        a11yHelpers.enableLegibleFonts();
      }
      return;
    }
    case FEATURES.RESET: {
      a11yHelpers.resetAll();
      return;
    }
  }
};
